export enum PowderStructure {
	Fine = 0,
	Rough = 1,
	Smooth = 2,
}
